"use client";

import { useNavigate } from "react-router";
import { Button } from "../../app/components/ui/button";
import { useAuth } from "../../providers/AuthProvider";

export function ImpersonationBanner() {
  const { impersonation, business, endImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonation) return null;

  async function onExit() {
    await endImpersonation();
    navigate("/admin", { replace: true });
  }

  return (
    <div className="shrink-0 border-b border-amber-200 bg-amber-50 px-6 py-2 flex flex-wrap items-center justify-between gap-2 text-sm">
      <span className="text-amber-950">
        Viewing as <strong>{business?.name ?? "Business"}</strong> — read-only (impersonation)
      </span>
      <Button type="button" size="sm" variant="outline" onClick={() => void onExit()}>
        Exit impersonation
      </Button>
    </div>
  );
}
